import React from "react";
import { classNames, conditionallyCreateStyleObj } from "../../utils";
import { ButtonV2 } from "../ButtonV2";
export const M43CardWithTitleHTMLButton = ({ title, titleColor, titleAlignment, richText, backgroundColor, buttonLabel, buttonUrl, buttonOpenInNewTab = false, buttonDesign = "tmx2-6-rounded-blue-large", buttonAlignment, unorderedListStyle = "ul-style--none", unorderedListImageBulletUrl, unorderedListDesktopLayout = "ul-two-columns--large-view", imageUrl, imagePlacement = "card-top", imageAlignment = "center", minHeight, rowGap }) => {
    const checkHasButton = () => buttonLabel && buttonUrl;
    const getCustomStyleObj = () => conditionallyCreateStyleObj({
        "--title-color": titleColor,
        "--title-alignment": titleAlignment,
        "--button-alignment": buttonAlignment,
        "--background-color": backgroundColor,
        "--unordered-list-bullet-url": `url(${unorderedListImageBulletUrl})`,
        "--image-alignment": imageAlignment,
        "--card-min-height": minHeight !== undefined ? `${minHeight}px` : undefined,
        "--card-row-gap": rowGap !== undefined ? `${rowGap}px` : undefined,
    });
    const cardClassName = classNames("card-with-title-html-button", {
        [`card-with-title-html-button--${unorderedListStyle}`]: !!unorderedListStyle,
        [`card-with-title-html-button--${unorderedListDesktopLayout}`]: !!unorderedListDesktopLayout,
        "card-with-title-html-button--with-image": !!imageUrl,
        [`card-with-title-html-button--with-image--${imagePlacement}`]: !!imageUrl
    });
    const customStyleObj = getCustomStyleObj();
    const hasButton = checkHasButton();
    return (React.createElement("div", { className: cardClassName, style: customStyleObj },
        imageUrl && React.createElement("img", { className: "card-with-title-html-button__image", src: imageUrl, alt: "" }),
        title && React.createElement("h3", { className: "card-with-title-html-button__title", dangerouslySetInnerHTML: { __html: title } }),
        React.createElement("div", { className: "card-with-title-html-button__rich-text", dangerouslySetInnerHTML: { __html: richText } }),
        hasButton && (React.createElement(ButtonV2, { design: buttonDesign, openInNewTab: buttonOpenInNewTab, href: buttonUrl }, buttonLabel))));
};
